import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { logPageView } from '../../models/Analytics';
import { MainContainer } from '../MainContainer';
import './styles.less';

interface IProps extends RouteComponentProps<any> {
	className?: string;
}

interface IState {
	errorMessage?: string;
	requestInviteEmail?: string;
}

export class About extends React.Component<IProps, IState> {
	public state: IState = {
		errorMessage: null,
		requestInviteEmail: '',
	};

	public componentDidMount() {
		window.scrollTo(0, 0);
		document.title = 'Levitate - About';
		logPageView('About');
	}

	public render() {
		return (
			<MainContainer activeSection='about'>
				<div className='about-heroContainer'>
					<h1 className='about-headline'>
						We love building software to help
						small businesses grow.
					</h1>
				</div>
				<div className='about-contentContainer'>
					<div className='about-contentBody'>
						<h2 className='about-contentBodyHeadline'>
							About Us
						</h2>
						<div className='about-contentBodyText'>
							<p>
								Levitate is built by Real Magic. Our mission is to help make the world a more entrepreneurial
								and creative place by building software that helps small businesses
								and small entrepreneurial teams within large companies grow.
							</p>
							<div className='about-contentBodyTwoColumnContainer'>
								<div className='about-headshot-jes-container'>
									<div className='about-headshot-jes' />
									<div>Jesse Lipson, Founder / CEO</div>
								</div>
								<div className='about-contentBodyTextRightColumn'>
									<p>
										Real Magic was founded by Jesse Lipson and some early team members from <a href='http://www.sharefile.com' target='_blank'>ShareFile</a> (now part of Citrix), an award-winning
										business file sharing and document workflow tool that is used by millions of business people around the world.
									</p>
									<p>
										We are backed by some great investors: <a href='https://tippetpartners.com/' target='_blank'>Tippett Partners</a>,
										Peter Gassner (co-founder and CEO of <a href='http://www.veeva.com' target='_blank'>Veeva Systems</a>),
										and <a href='http://www.bcvp.com' target='_blank'>Bull City Venture Partners</a>.
									</p>
									<p>
										We are based out of <a href='http://hq.community' target='_blank'>HQ</a> in downtown Raleigh, North Carolina.
									</p>
								</div>
							</div>
							<div className='about-articles'>
								<strong>Some news articles about Real Magic and Levitate:</strong>
								<p>
									<strong>April 2020 </strong>
									<a href='/#/press-releases/hawksoft' target='_blank'>
										Levitate announces integration with HawkSoft Agency Management System
									</a>
								</p>
								<p>
									<strong>Jun 2019: </strong>
									<a href='https://www.wraltechwire.com/2019/06/20/raleigh-startup-exec-jesse-lipson-lands-6m-for-real-magic-app-startup/' target='_blank'>
										Raleigh Startup Real Magic raises $6M
									</a>
								</p>
								<p>
									<strong>Jan 2019: </strong>
									<a href='https://medium.com/@scotwingo/the-inaugural-2019-tweener-list-celebration-and-awards-event-highlights-and-pics-6801e219931c' target='_blank'>
										Levitate named one of Triangle's most promising startups of 2019
									</a>
								</p>
								<p>
									<strong>Dec 2018: </strong>
									<a href='http://redrocketvc.blogspot.com/2018/12/red-rockets-best-startups-of-2018.html' target='_blank'>
										Levitate named one of the best startups of 2018
									</a>
								</p>
								<p>
									<strong>Dec 2018: </strong>
									<a href='https://www.wraltechwire.com/2018/12/14/qa-exclusive-jesse-lipson-talks-starting-first-company-at-23-sharefiles-success-latest-venture-more/' target='_blank'>
										WRAL Q&amp;A with Levitate founder Jesse Lipson
									</a>
								</p>
								<p>
									<strong>Sep 2018: </strong>
									<a href='https://www.youtube.com/watch?v=7bY9ac5ISbU' target='_blank'>
										Jesse Lipson (Levitate founder) TED Talk 2018
									</a>
								</p>
								<p>
									<strong>Oct 2017: </strong>
									<a href='https://www.wraltechwire.com/2017/10/31/jesse-lipson-why-hes-going-back-to-work-and-targeting-smaller-businesses/' target='_blank'>
										Jesse Lipson's next venture
									</a>
								</p>
								<p>
									<strong>Feb 2017: </strong>
									<a href='http://www.newsobserver.com/news/business/article134043889.html' target='_blank'>
										Citrix Systems executive eyes new startup
									</a>
								</p>
							</div>
						</div>
					</div>
				</div>
			</MainContainer>
		);
	}
}
